export function formatDurationMin(min, { showUnitForMinutes = true } = {}) {
  if (min === null || min === undefined || Number.isNaN(min)) return null;
  const totalMin = Math.round(Number(min));
  if (!Number.isFinite(totalMin) || totalMin < 0) return null;

  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;

  if (h <= 0) {
    return showUnitForMinutes ? `${totalMin} min` : String(totalMin);
  }
  return `${h}h${String(m).padStart(2, '0')}`;
}

